<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="my-10 px-4">
      <div class="flex justify-center items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">
          {{ __('Create order #:id notification', { id: job.id }) }}
        </h1>
      </div>

      <div class="bg-white px-4 py-10 shadow-md mt-10 overflow-x-auto">
        <div v-if="!type">
          <h2 class="text-2xl text-center text-gray-800">{{ __('Pick notification type') }}:</h2>

          <div class="flex justify-center mt-6">
            <inertia-link :disabled="!job.permissions.update" :href="route('approvalRequests.create', {job: job.id})" class="flex items-center justify-center bg-coral-400 text-white w-48 h-48 mx-6 text-lg font-semibold hover:bg-coral-300">
              {{ __('actionRequestType.request') }}
            </inertia-link>

            <inertia-link :disabled="!job.permissions.update" :href="route('jobCompleteRequests.create', {job: job.id})" class="flex items-center justify-center bg-coral-400 text-white w-48 h-48 mx-6 text-lg font-semibold hover:bg-coral-300">
              {{ __('actionRequestType.complete') }}
            </inertia-link>

            <inertia-link :disabled="!job.permissions.update" :href="route('feedbackRequests.create', {job: job.id})" class="flex items-center justify-center bg-coral-400 text-white w-48 h-48 mx-6 text-lg font-semibold hover:bg-coral-300">
              {{ __('actionRequestType.feedback') }}
            </inertia-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';
import CheckboxField from '@/Shared/CheckboxField';
import JobMenu from '../Jobs/JobMenu';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Create order #:id notification', { id: this.job.id }),
    };
  },
  props: {
    type: String,
    job: Object,
  },
  components: {
    Layout,
    Pagination,
    Icon,
    JobMenu,
    CheckboxField,
  },
};
</script>
